import {
  ADD_DEPARTMENT_FAILURE,
  ADD_DEPARTMENT_REQUEST,
  ADD_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAILURE,
  DELETE_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT_SUCCESS,
  FETCH_DEPARTMENT_FAILURE,
  FETCH_DEPARTMENT_REQUEST,
  FETCH_DEPARTMENT_SUCCESS,
  FETCH_LIST_DEPARTMENT_FAILURE,
  FETCH_LIST_DEPARTMENT_REQUEST,
  FETCH_LIST_DEPARTMENT_SUCCESS,
  RESET_CURRENT_DEPARTMENT,
  UPDATE_DEPARTMENT_FAILURE,
  UPDATE_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENT_SUCCESS,
  FETCH_COMMON_DEPARTMENT_REQUEST,
  FETCH_COMMON_DEPARTMENT_SUCCESS,
  FETCH_COMMON_DEPARTMENT_FAILURE
} from "./departmentType";
  
  export const fetchDepartments = () => {
 
  return {
    type: FETCH_LIST_DEPARTMENT_REQUEST,
  };
};
  
  export const fetchDepartmentsSuccess = (departments) => ({
    type: FETCH_LIST_DEPARTMENT_SUCCESS,
    payload: { departments },
  });
  
  export const fetchDepartmentsFailure = (error) => ({
    type: FETCH_LIST_DEPARTMENT_FAILURE,
    payload: { error },
  });
  

  export const fetchDepartment = (departmentId) => ({
    type: FETCH_DEPARTMENT_REQUEST,
    payload: { departmentId },
  });
  
  export const fetchDepartmentSuccess = (department) => ({
    type: FETCH_DEPARTMENT_SUCCESS,
    payload: { department },
  });
  
  export const fetchDepartmentFailure = (error) => ({
    type: FETCH_DEPARTMENT_FAILURE,
    payload: { error },
  });
  
 
  export const addDepartment = (departmentData) => ({
    type: ADD_DEPARTMENT_REQUEST,
    payload: { departmentData },
  });
  
  export const addDepartmentSuccess = (department) => ({
    type: ADD_DEPARTMENT_SUCCESS,
    payload: { department },
  });
  
  export const addDepartmentFailure = (error) => ({
    type: ADD_DEPARTMENT_FAILURE,
    payload: { error },
  });
  

  export const updateDepartment = (departmentId, departmentData) => ({
    type: UPDATE_DEPARTMENT_REQUEST,
    payload: { departmentId, departmentData },
  });
  
  export const updateDepartmentSuccess = (department) => ({
    type: UPDATE_DEPARTMENT_SUCCESS,
    payload: { department },
  });
  
  export const updateDepartmentFailure = (error) => ({
    type: UPDATE_DEPARTMENT_FAILURE,
    payload: { error },
  });
  
 
  export const deleteDepartment = (departmentId) => ({
    type: DELETE_DEPARTMENT_REQUEST,
    payload: { departmentId },
  });
  
  export const deleteDepartmentSuccess = (departmentId) => ({
    type: DELETE_DEPARTMENT_SUCCESS,
    payload: { departmentId },
  });
  
  export const deleteDepartmentFailure = (error) => ({
    type: DELETE_DEPARTMENT_FAILURE,
    payload: { error },
  });
  

  export const resetCurrentDepartment = () => ({
    type: RESET_CURRENT_DEPARTMENT,
  });

  export const fetchCommonDepartments = () => (
    console.log("fetchCommonDepartments"),
    {
    type: FETCH_COMMON_DEPARTMENT_REQUEST,
  }
  );

  export const fetchCommonDepartmentsSuccess = (departments) => ({
    type: FETCH_COMMON_DEPARTMENT_SUCCESS,
    payload: { departments },
  });

  export const fetchCommonDepartmentsFailure = (error) => ({
    type: FETCH_COMMON_DEPARTMENT_FAILURE,
    payload: { error },
  });